import Component from 'can/component/component';
import template from './simulation-config.stache';
import dispatcher from 'scripts/services/simulation-dispatcher';
import sessionStorage from 'scripts/services/sessionstorage-service';
import can from 'can';
import dayjs from 'dayjs';
import flatpickr from 'vendors/flatpickr/flatpickr';

const SIMULATION_STORAGE_KEY = 'usopen:simulation';

Component.extend({
    tag: 'simulation-config',
    template: template,
    viewModel: {
        updateStartDate(value) {
            if (value) {
                this.attr('config.startDate', dayjs(value + 'Z').valueOf());
            }
        },
        updateSimulationId(value) {
            this.attr('config.id', value.trim());
        },
        setTimeScaleFactor(value) {
            if (value) {
                this.attr('config.timeScaleFactor', value);
            }
        },
        getLastTime() {
            return this.attr('config.currentDate')
                ? ', last time: ' +
                      dayjs(this.config.currentDate)
                          .utc()
                          .format('DD MMMM YYYY HH:mm:ss')
                : '';
        },
        opened: false,
        status: can.compute(function() {
            const state = this.attr('config.state');
            const currentDate = this.attr('config.currentDate');

            if (state === 'start') {
                return 'Simulation is started' + this.getLastTime();
            }
            if (state === 'pause') {
                return 'Simulation is paused' + this.getLastTime();
            }

            return 'Simulation is stopped';
        }),
        getStartDate: can.compute(function() {
            let formattedDate = dayjs(this.attr('config.startDate'))
                .utc()
                .format('YYYY-MM-DD HH:mm');

            return formattedDate;
        }),
        define: {
            config: {
                Type: can.Map,
                value: null,
            },
            timeScaleFactors: {
                get: function() {
                    return [1, 2, 5, 10, 25, 100];
                },
            },
            isSuspended: {
                get: function() {
                    return (
                        ['stop', 'pause'].indexOf(this.config.attr('state')) >
                        -1
                    );
                },
            },
        },
    },
    events: {
        init() {
            this.initConfig();
            dispatcher.on('currentDateChange', (ev, currentDate) => {
                if (currentDate) {
                    this.viewModel.attr('config.currentDate', currentDate);
                }
            });
        },

        initConfig() {
            const data = this.deserialize();

            this.viewModel.attr(
                'config',
                new can.Map(
                    can.extend(
                        {
                            id: 'USOpen2019',
                            startDate: dayjs('2019-06-13T06:00:00Z')
                                .utc()
                                .valueOf(),
                            timeScaleFactor: 1,
                            state: 'stop',
                        },
                        data || {},
                    ),
                ),
            );

            dispatcher.dispatchDelayed(
                'configInitialize',
                this.viewModel.attr('config').serialize(),
            );

            this.viewModel.attr('config').bind('change', () => {
                dispatcher.dispatchDelayed(
                    'configInitialize',
                    this.viewModel.attr('config').serialize(),
                );
                this.serialize();
            });
        },

        serialize() {
            sessionStorage.setItem(
                SIMULATION_STORAGE_KEY,
                this.viewModel.attr('config').serialize(),
            );
        },

        deserialize() {
            try {
                return sessionStorage.getItem(SIMULATION_STORAGE_KEY);
            } catch (e) {
                console.error(
                    `Deserialization error: ${SIMULATION_STORAGE_KEY} - ${e.message}`,
                );
            }

            return null;
        },

        inserted() {
            new flatpickr(this.element.find('.s-form-start-date')[0], {
                utc: false,
                enableTime: true,
            });
        },

        addPaddingForSimulationBox() {
            $('.main-content').css(
                'padding-top',
                $('.c-simulation-config ').height(),
            );
        },

        '.s-form-toggle click'(el, ev) {
            ev.preventDefault();
            this.viewModel.attr('opened', !this.viewModel.opened);
            this.addPaddingForSimulationBox();
        },

        '.js-control click'($element) {
            const state = $element.attr('data-state');

            this.viewModel.attr('config.state', state);
            if (state === 'stop') {
                this.viewModel.removeAttr('config.currentDate');
            }
            dispatcher.dispatch('configChange', [this.viewModel.config]);
        },
    },
});
